module.exports = __webpack_public_path__ + "img/Manley.b99fe0b1.jpeg";